var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSuperLikeMiddle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSuperLikeMiddle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.4439307,48.5 C20.3555316,48.5 20.2660837,48.478285 20.1854757,48.4350039 C20.0086776,48.3407074 19.8985533,48.1567252 19.8985533,47.9584646 L19.8985533,40.2437049 C15.1235048,37.7789084 12.5,33.4634321 12.5,28.0564074 C12.5,19.7004615 20.2377661,13.4 30.5,13.4 C40.7622339,13.4 48.5,19.7004615 48.5,28.0564074 C48.5,36.4111634 40.7622339,42.7116249 30.5,42.7116249 C30.1628849,42.7116249 29.8323622,42.6933308 29.5007908,42.675929 L29.4789157,42.6748879 L20.7438882,48.4100168 C20.6533915,48.4696586 20.5486611,48.5 20.4439307,48.5 Z M22.175,30.95 C23.4176407,30.95 24.425,29.9426407 24.425,28.7 C24.425,27.4573593 23.4176407,26.45 22.175,26.45 C20.9323593,26.45 19.925,27.4573593 19.925,28.7 C19.925,29.9426407 20.9323593,30.95 22.175,30.95 Z M30.5,30.95 C31.7426407,30.95 32.75,29.9426407 32.75,28.7 C32.75,27.4573593 31.7426407,26.45 30.5,26.45 C29.2573593,26.45 28.25,27.4573593 28.25,28.7 C28.25,29.9426407 29.2573593,30.95 30.5,30.95 Z M38.825,30.95 C40.0676407,30.95 41.075,29.9426407 41.075,28.7 C41.075,27.4573593 40.0676407,26.45 38.825,26.45 C37.5823593,26.45 36.575,27.4573593 36.575,28.7 C36.575,29.9426407 37.5823593,30.95 38.825,30.95 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icSuperLikeMiddle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,1.0658141e-13 C13.5002729,1.0658141e-13 0,13.5002729 0,30 C0,46.4997271 13.5002729,60 30,60 C46.4997271,60 60,46.4997271 60,30 C60,13.5002729 46.4997271,1.0658141e-13 30,1.0658141e-13 Z",
    id: "Stroke-1",
    fill: "#7BCB45",
    transform: "translate(30.000000, 30.000000) rotate(-360.000000) translate(-30.000000, -30.000000) "
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuperLikeMiddle);
export default __webpack_public_path__ + "static/media/icSuperLikeMiddle.5c6a5aa2c70aa505ce5e800490faa6a9.svg";
export { ForwardRef as ReactComponent };